// Add here the components that you want to bootstrap on PHP pages
import { TrackingComponent } from '@shared/tracking';
import { CompatMessagingComponent } from './compat-messaging.component';
import { CompatNavigationEmptyComponent } from './compat-navigation-empty.component';
import { CompatNavigationSecondaryAboutComponent } from './compat-navigation-secondary-about.component';
import { CompatNavigationSecondaryCommunityComponent } from './compat-navigation-secondary-community.component';
import { CompatNavigationSecondaryContestsComponent } from './compat-navigation-secondary-contests.component';
import { CompatNavigationSecondaryFinancesComponent } from './compat-navigation-secondary-finances.component';
import { CompatNavigationSecondaryHelpComponent } from './compat-navigation-secondary-help.component';
import { CompatNavigationSecondaryHireFreelancersComponent } from './compat-navigation-secondary-hire-freelancers.component';
import { CompatNavigationSecondaryLocalJobsComponent } from './compat-navigation-secondary-local-jobs.component';
import { CompatNavigationSecondaryMySkillsComponent } from './compat-navigation-secondary-my-skills.component';
import { CompatNavigationSecondaryProfileComponent } from './compat-navigation-secondary-profile.component';
import { CompatNavigationSecondaryProjectsComponent } from './compat-navigation-secondary-projects.component';
import { CompatNavigationSecondaryShowcaseComponent } from './compat-navigation-secondary-showcase.component';
import { CompatNavigationComponent } from './compat-navigation.component';

export const components = [
  {
    selector: 'webapp-compat-tracking',
    loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
    component: TrackingComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation',
    loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
    component: CompatNavigationComponent,
    path: 'hack_path_not_used_index_0',
  },
  {
    selector: 'webapp-compat-navigation-empty',
    loadChildren:
      'compat/compat-navigation-empty.module#CompatNavigationEmptyModule',
    component: CompatNavigationEmptyComponent,
    path: 'hack_path_not_used_index_0',
  },
  {
    selector: 'webapp-compat-navigation-secondary-projects',
    loadChildren:
      'compat/compat-navigation-secondary-projects.module#CompatNavigationSecondaryProjectsModule',
    component: CompatNavigationSecondaryProjectsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-about',
    loadChildren:
      'compat/compat-navigation-secondary-about.module#CompatNavigationSecondaryAboutModule',
    component: CompatNavigationSecondaryAboutComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-contests',
    loadChildren:
      'compat/compat-navigation-secondary-contests.module#CompatNavigationSecondaryContestsModule',
    component: CompatNavigationSecondaryContestsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-community',
    loadChildren:
      'compat/compat-navigation-secondary-community.module#CompatNavigationSecondaryCommunityModule',
    component: CompatNavigationSecondaryCommunityComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-profile',
    loadChildren:
      'compat/compat-navigation-secondary-profile.module#CompatNavigationSecondaryProfileModule',
    component: CompatNavigationSecondaryProfileComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-showcase',
    loadChildren:
      'compat/compat-navigation-secondary-showcase.module#CompatNavigationSecondaryShowcaseModule',
    component: CompatNavigationSecondaryShowcaseComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-local-jobs',
    loadChildren:
      'compat/compat-navigation-secondary-local-jobs.module#CompatNavigationSecondaryLocalJobsModule',
    component: CompatNavigationSecondaryLocalJobsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-finances',
    loadChildren:
      'compat/compat-navigation-secondary-finances.module#CompatNavigationSecondaryFinancesModule',
    component: CompatNavigationSecondaryFinancesComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-my-skills',
    loadChildren:
      'compat/compat-navigation-secondary-my-skills.module#CompatNavigationSecondaryMySkillsModule',
    component: CompatNavigationSecondaryMySkillsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-hire-freelancers',
    loadChildren:
      'compat/compat-navigation-secondary-hire-freelancers.module#CompatNavigationSecondaryHireFreelancersModule',
    component: CompatNavigationSecondaryHireFreelancersComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-help',
    loadChildren:
      'compat/compat-navigation-secondary-help.module#CompatNavigationSecondaryHelpModule',
    component: CompatNavigationSecondaryHelpComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-messaging',
    loadChildren: 'compat/compat-messaging.module#CompatMessagingModule',
    component: CompatMessagingComponent,
    path: 'hack_path_not_used',
  },
];



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/compat/components.ts